module.exports = __webpack_public_path__ + "static/media/icon_iron.f5d5c398.svg";